<template>
  <v-container>
    <div class="text-center">
      <br /><br />
      <strong>AMIA Baseline Survey is under construction. </strong>
      <br />
      Please contact the admin for more info.
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'UnderConstruction',
}
</script>
